export enum PAGE {
	MATTER_PARTIES_CLIENTS = 'matter_parties_clients',
	MATTER_PARTIES_OTHER = 'matter_parties_other',
}

export enum SITE_SECTION {
	Matter = 'matter',
	Settings = 'settings',
	MatterCreation = 'matter-creation',
	MatterPackage = 'matter-package',
}
